import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const inventoryCategoryMasterService = createApi({
  reducerPath: "inventoryCategoryMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["inventoryCategoryMaster"],
  endpoints: (builder) => ({
    // ✅ Get All with Pagination
    getAllInventoryCategoryMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryCategoryMasterController.getAllInventoryCategoryMasterWithPagination}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),

    // ✅ Search
    searchInventoryCategoryMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryCategoryMasterController.searchInventoryCategoryMaster}`,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),

    // ✅ Save
    saveInventoryCategoryMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryCategoryMasterController.saveInventoryCategoryMaster}`,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),

    // ✅ Update
    updateInventoryCategoryMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryCategoryMasterController.updateInventoryCategoryMaster}/${body.id}`,
        method: "PUT",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),

    // ✅ Delete
    deleteInventoryCategoryMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryCategoryMasterController.deleteInventoryCategoryMaster}/${body.id}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),

    // ✅ Get by ID
    getInventoryCategoryMasterById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryCategoryMasterController.getInventoryCategoryMasterById}/${body.id}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),

    // ✅ Get All without pagination
    findAllInventoryCategoryMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryCategoryMasterController.getAllInventoryCategoryMaster}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),

    // ✅ Bulk Upload
    bulkUploadInventoryCategoryMaster: builder.mutation({
      query: (body) => {
        return {
          url: `${userManagement.inventoryCategoryMasterController.bulkUploadInventoryCategoryMaster}`,
          method: "POST",
          body: body.payload,
          headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
  }),
});

export const {
  useGetAllInventoryCategoryMasterMutation,
  useSearchInventoryCategoryMasterMutation,
  useSaveInventoryCategoryMasterMutation,
  useUpdateInventoryCategoryMasterMutation,
  useDeleteInventoryCategoryMasterMutation,
  useGetInventoryCategoryMasterByIdMutation,
  useFindAllInventoryCategoryMasterMutation,
  useBulkUploadInventoryCategoryMasterMutation,
} = inventoryCategoryMasterService;
